export const INDICATOR_TABLE_REQUEST = "INDICATOR_TABLE_REQUEST";
export const INDICATOR_TABLE_CU = "INDICATOR_TABLE_CU";
export const INDICATOR_TABLE_UPDATED = "INDICATOR_TABLE_UPDATED";
export const INDICATOR_TABLE_DELETE = "INDICATOR_TABLE_DELETE";
export const INDICATOR_TABLE_ERROR = "INDICATOR_TABLE_ERROR";
export const INDICATOR_TABLE_LOADED = "INDICATOR_TABLE_LOADED";
export const INDICATOR_TABLE_REGION_CU = "INDICATOR_TABLE_REGION_CU";
export const INDICATOR_TABLE_VERIFY = "INDICATOR_TABLE_VERIFY";